module.exports = __webpack_public_path__ + "media/images/2-d42251a4b8e58421b3d8c3e8b389d164.png";